module.exports = __webpack_public_path__ + "static/media/ios-shirt.bd6ff6e1.svg";